// extracted by mini-css-extract-plugin
export default {"container":"style_container__pDjvF","icon":"style_icon__YWpZ2"};